import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import App from './jsx/containers/App.jsx';
import store from './store';

const app = document.getElementById('root');
const root = createRoot(app);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
